import React from 'react';

const BirdsBreedIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3826 3.07458L14.2474 2.20972"
            stroke="#1F2F3B"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4789 3.46167C11.5613 3.46156 11.6428 3.4777 11.7189 3.50917C11.795 3.54063 11.8641 3.58679 11.9224 3.64501C11.9806 3.70324 12.0268 3.77238 12.0582 3.84847C12.0897 3.92456 12.1058 4.00611 12.1057 4.08845C12.1056 4.21219 12.0687 4.3331 11.9999 4.43592C11.931 4.53875 11.8333 4.61885 11.7189 4.66613C11.6046 4.71341 11.4788 4.72574 11.3574 4.70156C11.2361 4.67738 11.1246 4.61778 11.0371 4.53028C10.9496 4.44278 10.89 4.33131 10.8658 4.20997C10.8416 4.08861 10.854 3.96282 10.9013 3.84847C10.9485 3.73412 11.0286 3.63635 11.1315 3.5675C11.2343 3.49866 11.3552 3.46183 11.4789 3.46167Z"
            fill="#1F2F3B"
        />
        <path
            d="M13.671 4.51595C13.671 3.24225 12.6384 2.20972 11.3647 2.20972C10.925 2.20972 10.5139 2.33281 10.1642 2.54643C9.89056 2.7136 9.68782 2.96994 9.50108 3.23063L1.75269 12.2995H9.0043C11.5816 12.2995 13.671 10.2101 13.671 7.63282V4.51595Z"
            stroke="#1F2F3B"
            strokeLinejoin="round"
        />
        <path
            d="M3.00464 12.2996L4.10357 12.2996C6.68089 12.2995 8.77022 10.2102 8.77022 7.63289V5.32169C8.77022 4.62538 8.98828 3.94655 9.39378 3.3805L9.50108 3.23071"
            stroke="#1F2F3B"
            strokeLinejoin="round"
        />
        <path
            d="M6.42725 12.2253L7.99219 13.7903M6.74023 13.7903H9.55713"
            stroke="#1F2F3B"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default BirdsBreedIcon;
